document.addEventListener("DOMContentLoaded", function () {
    

    //collection url change 
    const urlMap = {
    "/collections/baby-lock": "/pages/baby-lock-brands",
    "/collections/bernina": "/pages/bernina-brands",
    "/collections/brother": "/pages/brother-brands",
    "/collections/consew": "/pages/consew-brands",
    "/collections/flor-ani": "/pages/floriani-brand",
    "/collections/handi-quilter": "/pages/handi-quilter-brands",
    "/collections/husqvarna-viking": "/pages/viking-brands",
    "/collections/sewing-machines-1": "/pages/sewing-machines",
    "/collections/quilting-machines": "/pages/quilting-supplies",
    "/collections/sewing-furniture": "/pages/sewing-furniture-1"
    };

    document.querySelectorAll('a[href]').forEach(link => {
    const currentHref = link.getAttribute('href');
    if (urlMap[currentHref]) {
        link.setAttribute('href', urlMap[currentHref]);
    }
    });



    //Home Page Featured Products Tab
    let featured_tabs = document.querySelector('.featured-tabs-section');
    if (featured_tabs) {
        const tabButtons = featured_tabs.querySelectorAll(".tab-btn");
        const tabPanels = featured_tabs.querySelectorAll(".tab-panel");

        tabButtons.forEach(button => {
            button.addEventListener("click", () => {
                const target = button.getAttribute("data-tab");

                // Remove active class from all
                tabButtons.forEach(btn => btn.classList.remove("active"));
                tabPanels.forEach(panel => panel.classList.remove("active"));

                // Add active to clicked
                button.classList.add("active");
                document.getElementById(target).classList.add("active");
            });
        });
    }


    // ----------------------
    // Home page Review Section Slider
    // ----------------------

    function createReviewSlider(mainSelector, containerSelector, itemSelector) {
        const reviewSection = document.querySelector(mainSelector);
        if (!reviewSection) return;

        const reviewSlider = reviewSection.querySelector(containerSelector);
        const reviewSlides = reviewSlider ? reviewSlider.querySelectorAll(itemSelector) : [];
        if (!reviewSlider || !reviewSlides.length) return;

        // dots container create
        const dotsContainer = document.createElement("div");
        dotsContainer.className = "dots";
        reviewSection.appendChild(dotsContainer);

        let currentIndex = 0;
        let startX = 0,
            endX = 0,
            isDragging = false;

        // Slides per view: mobile=1, desktop=3
        function slidesPerView() {
            return window.innerWidth < 768 ? 1 : 3;
        }

        function initDots() {
            dotsContainer.innerHTML = "";
            const perView = slidesPerView();
            const totalDots = reviewSlides.length - perView + 1; // ✅ fix: dots count

            for (let i = 0; i < totalDots; i++) {
                const dot = document.createElement("button");
                if (i === 0) dot.classList.add("active");
                dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
                dot.setAttribute("role", "button");
                dot.addEventListener("click", () => goToSlide(i));
                dotsContainer.appendChild(dot);
            }
        }

        function goToSlide(index) {
            const perView = slidesPerView();
            const maxIndex = reviewSlides.length - perView;

            if (index < 0) index = 0;
            if (index > maxIndex) index = maxIndex;

            currentIndex = index;

            // % calculation (1 slide = 100 / perView width)
            const percent = (100 / perView) * index;
            reviewSlider.style.transform = `translateX(-${percent}%)`;

            updateDots();
        }

        function updateDots() {
            dotsContainer.querySelectorAll("button").forEach((dot, i) => {
                dot.classList.toggle("active", i === currentIndex);
            });
        }

        function enableSlider() {
            reviewSlider.style.display = "flex";
            reviewSlider.style.transition = "transform 0.3s ease-in-out";
            initDots();

            // ✅ Touch + Mouse drag support
            function dragStart(e) {
                isDragging = true;
                startX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
            }

            function dragMove(e) {
                if (!isDragging) return;
                endX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
            }

            function dragEnd() {
                if (!isDragging) return;
                isDragging = false;

                let diff = startX - endX;
                if (Math.abs(diff) > 50) {
                    goToSlide(diff > 0 ? currentIndex + 1 : currentIndex - 1);
                } else {
                    goToSlide(currentIndex); // snap back
                }
            }

            // Touch events
            reviewSlider.addEventListener("touchstart", dragStart);
            reviewSlider.addEventListener("touchmove", dragMove);
            reviewSlider.addEventListener("touchend", dragEnd);

            // Mouse events
            reviewSlider.addEventListener("mousedown", dragStart);
            reviewSlider.addEventListener("mousemove", dragMove);
            reviewSlider.addEventListener("mouseup", dragEnd);
            reviewSlider.addEventListener("mouseleave", dragEnd);
        }

        function handleResize() {
            initDots();
            goToSlide(0); // reset on resize
        }

        // Init
        enableSlider();
        window.addEventListener("resize", handleResize);
    }

    createReviewSlider(
        ".review_section",
        ".group-block:nth-child(2) > .group-block-content",
        ":scope > .group-block"
    );


    // Home Page Blog Slider
    function createBlogSlider(mainSelector, containerSelector, itemSelector) {
        const blogSection = document.querySelector(mainSelector);
        if (!blogSection) return;

        const blogContainer = blogSection.querySelector(containerSelector);
        const blogItems = blogContainer ? blogContainer.querySelectorAll(itemSelector) : [];
        if (!blogContainer || !blogItems.length) return;

        // Mobile only
        if (window.innerWidth > 767) return;

        // Dots container
        const blogDotsContainer = document.createElement("div");
        blogDotsContainer.className = "blog-dots";
        blogSection.appendChild(blogDotsContainer);

        let blogCurrentIndex = 0;
        let blogStartX = 0,
            blogEndX = 0,
            blogIsDragging = false;

        function slidesPerView() {
            return 1; // mobile = 1 slide
        }

        function initDots() {
            blogDotsContainer.innerHTML = "";
            const totalDots = blogItems.length - slidesPerView() + 1;

            for (let i = 0; i < totalDots; i++) {
                const dot = document.createElement("button");
                if (i === 0) dot.classList.add("active");
                   dot.setAttribute("aria-label", `Go to slide ${i + 1}`);
                   dot.setAttribute("role", "button");
                dot.addEventListener("click", () => goToSlide(i));
                blogDotsContainer.appendChild(dot);
            }
        }

        function goToSlide(index) {
            const perView = slidesPerView();
            const maxIndex = blogItems.length - perView;

            if (index < 0) index = 0;
            if (index > maxIndex) index = maxIndex;

            blogCurrentIndex = index;

            const percent = (100 / perView) * index;
            blogContainer.style.transform = `translateX(-${percent}%)`;

            updateDots();
        }

        function updateDots() {
            blogDotsContainer.querySelectorAll("button").forEach((dot, i) => {
                dot.classList.toggle("active", i === blogCurrentIndex);
            });
        }

        function enableSlider() {
            blogContainer.style.display = "flex";
            blogContainer.style.transition = "transform 0.3s ease-in-out";
            initDots();

            // Touch + Mouse drag
            function dragStart(e) {
                blogIsDragging = true;
                blogStartX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
            }

            function dragMove(e) {
                if (!blogIsDragging) return;
                blogEndX = e.type.includes("mouse") ? e.clientX : e.touches[0].clientX;
            }

            function dragEnd() {
                if (!blogIsDragging) return;
                blogIsDragging = false;

                const diff = blogStartX - blogEndX;
                if (Math.abs(diff) > 50) {
                    goToSlide(diff > 0 ? blogCurrentIndex + 1 : blogCurrentIndex - 1);
                } else {
                    goToSlide(blogCurrentIndex); // snap back
                }
            }

            blogContainer.addEventListener("touchstart", dragStart);
            blogContainer.addEventListener("touchmove", dragMove);
            blogContainer.addEventListener("touchend", dragEnd);

            blogContainer.addEventListener("mousedown", dragStart);
            blogContainer.addEventListener("mousemove", dragMove);
            blogContainer.addEventListener("mouseup", dragEnd);
            blogContainer.addEventListener("mouseleave", dragEnd);
        }

        function handleResize() {
            if (window.innerWidth > 767) return; // mobile only
            initDots();
            goToSlide(0);
        }

        enableSlider();
        window.addEventListener("resize", handleResize);
    }

    // Usage
    createBlogSlider(".custom_blog", ".blog-posts-container", ".blog-post-item");



    //Desktop Mega menu
    document.querySelectorAll(".menu-list__list-item > a").forEach(function (anchor) {
        anchor.addEventListener("click", function (e) {
            let parentLi = this.closest(".menu-link");
            if (parentLi && parentLi.querySelector(".dropdown-child ul")) {
                e.preventDefault();
                parentLi.parentElement.querySelectorAll(".menu-link").forEach(function (li) {
                    if (li !== parentLi) li.classList.remove("open");
                });
                parentLi.classList.toggle("open");
            }
        });
    });

    // Second level (grandchild) menu toggle
    document.querySelectorAll(".dropdown-child ul > .menu-link > a").forEach(function (anchor) {
        anchor.addEventListener("click", function (e) {
            let parentLi = this.closest(".menu-link");
            if (parentLi && parentLi.querySelector(".dropdown-grandchild ul")) {
                e.preventDefault();
                parentLi.parentElement.querySelectorAll(".menu-link").forEach(function (li) {
                    if (li !== parentLi) li.classList.remove("open");
                });
                parentLi.classList.toggle("open");
            }
        });
    });

    //Remove Class body click
    document.addEventListener("click", function (e) {
        document.querySelectorAll(".menu-link").forEach(popup => {
            if (!popup.contains(e.target)) {
                popup.classList.remove("open");
            }
        });
    });

    //Header Search Box Close
    document.addEventListener("click", function (e) {
        const searchBox = document.querySelector(".custom_search_feild");
        const searchWrapper = document.querySelector('.predictive-search-form__content-wrapper');
        if (searchBox && searchWrapper) {
            if (!searchBox.contains(e.target)) {
                searchWrapper.style.visibility = "hidden";
            }
        }
    });

//Serach Popup Close
    const search_input = document.querySelector('.custom_search_feild .search-input');
    if (search_input) {
        search_input.addEventListener('input', function () {
            const inputValue = search_input.value.trim();
            const charCount = inputValue.length;
            if (charCount > 2) {
                const searchWrapper = document.querySelector('.predictive-search-form__content-wrapper');
                if (searchWrapper) {
                    if (searchWrapper.style.visibility === 'hidden') {
                        searchWrapper.style.visibility = 'visible';
                    }
                }
            }
        });
    }



    //==============Product Page JS =============//
    const tmpProduct = document.querySelector('.tmp-product');
    if (tmpProduct) {
        //product page tab section
        let product_tabs = document.querySelector('.product_tab_content');
        if (product_tabs) {
            const tabs = product_tabs.querySelectorAll(".tab");
            const contents = product_tabs.querySelectorAll(".tab-content");

            tabs.forEach(tab => {
                tab.addEventListener("click", () => {
                    let target = tab.getAttribute("data-tab");

                    // Remove active class from all tabs & contents
                    tabs.forEach(t => t.classList.remove("active"));
                    contents.forEach(c => c.classList.remove("active"));

                    // Add active class to clicked tab & related content
                    tab.classList.add("active");
                    document.getElementById(target).classList.add("active");
                });
            });
        }



        // Thumbnail set Youtube Video
        let product_video = document.querySelector('.product-videos');
        if (product_video) {

            let wrappers = product_video.querySelectorAll('.wrapper');
            let length = wrappers.length;
            if (length > 4) {
                product_video.classList.add('slider_active');
            } else {
                product_video.classList.add('slider_notactive');
            }


            product_video.querySelectorAll(".youtube").forEach(el => {
                let id = el.dataset.embed;
                // Set thumbnail
                el.style.backgroundImage = `url(https://img.youtube.com/vi/${id}/hqdefault.jpg)`;

                // On click → open popup
                el.addEventListener("click", () => {
                    let popup = document.getElementById("video-popup");
                    let frame = document.getElementById("video-frame");

                    if (frame && popup) {
                        frame.src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&rel=0`;
                        popup.style.display = "block";
                        document.body.style.overflow = "hidden"; // prevent scroll
                    }
                });
            });

            // Close button click
            const closeBtn = document.querySelector(".video-popup .close");
            if (closeBtn) {
                closeBtn.addEventListener("click", () => {
                    let popup = document.getElementById("video-popup");
                    let frame = document.getElementById("video-frame");

                    if (frame) frame.src = "";
                    if (popup) popup.style.display = "none";

                    document.body.style.overflow = ""; // restore scroll
                });
            }

            let product_video2 = document.querySelector('#more-info-videos');
            if (product_video2) {
                product_video2.querySelectorAll(".youtube2").forEach(el => {
                    let id = el.dataset.embed;
                    // Set thumbnail
                    el.style.backgroundImage = `url(https://img.youtube.com/vi/${id}/hqdefault.jpg)`;

                    // On click → open popup
                    el.addEventListener("click", () => {
                        let popup = document.getElementById("video-popup");
                        let frame = document.getElementById("video-frame");

                        if (frame && popup) {
                            frame.src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&rel=0`;
                            popup.style.display = "block";
                            document.body.style.overflow = "hidden"; // prevent scroll
                        }
                    });
                });
            }


            // Outside click close
            window.addEventListener("click", e => {
                let popup = document.getElementById("video-popup");
                if (popup && e.target === popup) {
                    const closeBtn = document.querySelector(".video-popup .close");
                    if (closeBtn) closeBtn.click();
                }
            });
        }



        //Product Page Local
        var Local_popup = document.querySelector('.local_pop_main');
        if (Local_popup) {
            var popup_open = document.querySelector('.product_ship-availability #local-popup');
            if (popup_open) {
                popup_open.addEventListener('click', function () {
                    Local_popup.style.display = "block";
                });
            }

            var popup_close = document.querySelector('.local_pop_close');
            popup_close.addEventListener('click', function () {
                Local_popup.style.display = "none";
            });

            // Body par click listener
            document.addEventListener("click", function (e) {
                if (Local_popup && popup_open) {
                    if (!Local_popup.contains(e.target) && !popup_open.contains(e.target)) {
                        Local_popup.style.display = "none";
                    }
                }
            });

        }


        //Product page California Proposition Popup
        var warning_popup = document.querySelector('.warning_popup_one');
        if (warning_popup) {
            warning_popup.addEventListener('click', function () {
                document.querySelector('.california-proposition-popup-main').style.display = "block";
            });

            var popup_cl_close = document.querySelector('.cal-close');
            if (popup_cl_close) {
                popup_cl_close.addEventListener('click', function () {
                    document.querySelector('.california-proposition-popup-main').style.display = "none";
                });
            }
        }

           //Product page Essentials Packages Popup
            const essentialsPopupTrigger = document.querySelector('.essentials_packages p');
            const essentialsPopup = document.querySelector('.essentials_packages_popup');
            const popupCloseBtn = document.querySelector('.essentials_packages_close');

            if (essentialsPopupTrigger && essentialsPopup) {
            // Open popup
            essentialsPopupTrigger.addEventListener('click', (e) => {
                e.stopPropagation();
                essentialsPopup.style.display = 'block';
            });

            // Close popup on close button
            if (popupCloseBtn) {
                popupCloseBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                essentialsPopup.style.display = 'none';
                });
            }

            // Close popup when clicking outside
            document.addEventListener('click', (e) => {
                if (!essentialsPopup.contains(e.target)) {
                essentialsPopup.style.display = 'none';
                }
            });
            }



        // Product Page Manufacturer Warranty Popup
        var manufacturer_warranty = document.querySelector('.manufacturer_warranty');
        if (manufacturer_warranty) {
            let warranty_box = manufacturer_warranty.querySelectorAll('.warranty_box');
            warranty_box.forEach(function (item) {
                let viewBtn = item.querySelector('.view_warranty');
                if (viewBtn) {
                    viewBtn.addEventListener("click", function () {
                        const BoxCard = this.dataset.target;
                        const targetBox = item.querySelector(BoxCard);
                        if (targetBox) {
                            targetBox.style.display = "block";
                        }
                    });
                }

                var popup__close = document.querySelector('#moreInfo .modal-header .close');
                popup__close.addEventListener('click', function () {
                    manufacturer_warranty.querySelector('.modal').style.display = "none";
                });

                document.addEventListener("click", function (e) {
                    let warranty_box = manufacturer_warranty.querySelector('.warranty_box'); // single box
                    let modal = manufacturer_warranty.querySelector('.modal'); // single modal

                    if (warranty_box && modal) {
                        if (!warranty_box.contains(e.target)) {
                            modal.style.display = "none";
                        }
                    }
                });


            });
        }

        //Product page  tab one class ad
        const one_item = document.querySelector('.product_tab_content .tabs');
        if (one_item) {
            let tabs = one_item.querySelectorAll('.tab');
            if (tabs.length == 1) {
                tabs[0].classList.add('its_one'); // single tab pe class add
            }
        }



        document.querySelectorAll('.fcolc').forEach(div => {
            const links = [...div.querySelectorAll('a[rel^="lightbox"]')];
            const images = links.map(link => link.getAttribute('href') || link.querySelector('img')?.src);
          
            // Create popup container
            const popup = document.createElement('div');
            popup.className = 'enlarge-pop-up-box';
            popup.innerHTML = `
              <div class="pop-up-box-image-container">
                <button class="enlarge-pop-up-box-close-btn">&times;</button>
                <img class="enlarge-pop-up-box-img" src="" alt="">
                <button class="enlarge-pop-up-prev">&#10094;</button>
                <button class="enlarge-pop-up-next">&#10095;</button>
              </div>
            `;
            document.body.appendChild(popup);
          
            const img = popup.querySelector('img');
            const closeBtn = popup.querySelector('.enlarge-pop-up-box-close-btn');
            const prevBtn = popup.querySelector('.enlarge-pop-up-prev');
            const nextBtn = popup.querySelector('.enlarge-pop-up-next');
            let current = 0;
          
            function showImage(direction = 'next') {
              img.classList.remove('slide-in-left', 'slide-in-right');
              void img.offsetWidth;
              img.src = images[current];
              img.classList.add(direction === 'next' ? 'slide-in-right' : 'slide-in-left');
            }
          
            // Open popup only if rel starts with "lightbox"
            div.querySelectorAll('a').forEach(link => {
              link.addEventListener('click', e => {
                const rel = link.getAttribute('rel') || '';
                if (!rel.startsWith('lightbox')) {
                  return;
                }
          
                e.preventDefault();
                current = links.indexOf(link);
                if (current === -1) current = 0;
          
                img.src = images[current];
                popup.style.display = 'flex';
          
                const showNav = images.length > 1;
                prevBtn.style.display = showNav ? 'block' : 'none';
                nextBtn.style.display = showNav ? 'block' : 'none';
              });
            });
          
            // Controls
            closeBtn.onclick = () => (popup.style.display = 'none');
            popup.onclick = e => e.target === popup && (popup.style.display = 'none');
            prevBtn.onclick = () => (current = (current - 1 + images.length) % images.length, showImage('prev'));
            nextBtn.onclick = () => (current = (current + 1) % images.length, showImage('next'));
          });

          const dialogPopUpBoxes = document.querySelectorAll('[role="dialog"]');
 
if(dialogPopUpBoxes){
    function openDialogBox(dataTargetAttribute) {
        dialogPopUpBoxes.forEach(dialogPopUpBox => {
          const popUpBoxDialogId = dialogPopUpBox.getAttribute('id');
     
          if (dataTargetAttribute === popUpBoxDialogId) {
            dialogPopUpBox.classList.add("show");
            document.body.style.overflow = "hidden";
          } else {
            dialogPopUpBox.classList.remove("show");
          }
        });
      }
     
     
      // Close Modal Logic
      dialogPopUpBoxes.forEach(dialogPopUpBox => {
        const closeDialogBtns = dialogPopUpBox.querySelectorAll('[data-dismiss="modal"]');
        closeDialogBtns.forEach(closeDialogBtn => {
          closeDialogBtn.addEventListener('click', () => {
            dialogPopUpBox.classList.remove("show");
            document.body.style.overflow = "auto";
          });
      });
     
        // Click outside modal to close
        dialogPopUpBox.addEventListener('click', (e) => {
          if (e.target === dialogPopUpBox) {
            dialogPopUpBox.classList.remove("show");
            document.body.style.overflow = "auto";
          }
        });
      });
     
    }
      // Modal Buttons Logic
      const popUpButtons = document.querySelectorAll('[data-toggle="modal"]');
 
      if(popUpButtons){
        popUpButtons.forEach(popUpButton => {
            popUpButton.addEventListener('click', () => {
              let dataTargetAttribute = popUpButton.getAttribute('data-target');
         
              if (dataTargetAttribute.startsWith('#')) {
                dataTargetAttribute = dataTargetAttribute.substring(1);
                popUpButton.setAttribute('data-target', dataTargetAttribute);
              }
         
              openDialogBox(dataTargetAttribute);
            });
          });
      }
 
    }

    // Accessibility Click Drawer Open
    document.addEventListener('userway:init_completed', (event) => {
    const userwayInstance = event.detail.userWayInstance;
    const accessibilityBtn = document.querySelector('.menu__item.accessibility');
    if (accessibilityBtn) {
        accessibilityBtn.addEventListener('click', (e) => {
        e.preventDefault();
        userwayInstance.widgetOpen();
        });
    }
    });


    //Blog container Height adjust
    const blogContainer = document.querySelector('.tmp-index .blog-posts-container');
        if (blogContainer) {
            const blogItems = blogContainer.querySelectorAll('.blog-post-item .blog-post-card__content');
            let maxHeight = 0;
            blogItems.forEach(item => {
                const itemHeight = item.offsetHeight;
                if (itemHeight > maxHeight) {
                    maxHeight = itemHeight;
                }
            });
            blogItems.forEach(item => {
                item.style.height = `${maxHeight}px`;
            });
        }

//COllection Page Infinite Scroll
  var collectionContainer = document.querySelector('.collection_page_list');
  if (!collectionContainer) return; // stop if collection does not exist

  var soldOutShown = false;

  function showSoldOutIfLastPage() {
    if (soldOutShown) return; // Already shown, no need to run again

    var productItems = collectionContainer.querySelectorAll('.product-grid .product-grid__item');
    if (productItems.length === 0) return;

    var lastItem = productItems[productItems.length - 1];
    var currentPage = parseInt(lastItem.getAttribute('data-page'));
    var lastData = parseInt(lastItem.getAttribute('data-last'));

    if (!isNaN(currentPage) && !isNaN(lastData) && currentPage === lastData) {
      var soldOutItems = collectionContainer.querySelectorAll('.product-grid__item.soldout_product');
      soldOutItems.forEach(function(item) {
        item.style.display = 'block';
      });
      soldOutShown = true;
    }
  }
  showSoldOutIfLastPage();
  window.addEventListener('scroll', showSoldOutIfLastPage);


});